<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Basic</h4>
            <text-control label="First Name" v-model="item.firstName"></text-control>
            <text-control label="Last Name" v-model="item.lastName"></text-control>
            <text-control label="Organization" v-model="item.organization"></text-control>
          </b-card>
          <b-card class="mt-3">
            <h4 slot="header">Certification</h4>
            <checkbox-control label="Certified" v-model="item.isCertified"></checkbox-control>
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Contact</h4>
            <text-control label="Email Address" v-model="item.email" required></text-control>
            <text-control label="Phone Number" v-model="item.phoneNumber"></text-control>
            <checkbox-control label="Opt-In to Marketing Emails" v-model="item.sendMarketingEmails"></checkbox-control>
          </b-card>
          <b-card class="mt-3">
            <h4 slot="header">Address</h4>
            <text-control label="Address 1" v-model="item.address1"></text-control>
            <text-control label="Address 2" v-model="item.address2"></text-control>
            <text-control label="City" v-model="item.city"></text-control>
            <select-control label="State" description="Only required for U.S. locations" v-model="item.state" :options="states"></select-control>
            <select-control label="Country" v-model="item.country" :options="countries"></select-control>
            <text-control label="Postal Code" description="For U.S. locations, this is the ZIP code" v-model="item.postalCode"></text-control>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group>
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
            <slot name="buttons"></slot>
          </b-button-toolbar>
        </b-col>
      </b-row>
          
    </b-form>
  </div>
</template>

<script>
import Constants from '../Common/Constants.js'

export default {
  name: "ApplicationUserFields",
  props: [
      'item'
  ],
  data() {
    return {
      states: Constants.states,
      countries: Constants.countries
    };
  },
  methods: {
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    },
    validateState() {
      if (this.item.country == 'US' && this.item.state == '')
        return 'State is required when the country is U.S.';
      
      return true;
    },
    validateCountry() {
      if (this.item.country != 'US' && this.item.state != '')
        return 'Country must be U.S. when a state is selected';
      
      return true;
    }
  }
};
</script>